import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export enum ToggleOauth2ErrorTypes {
  ActionFailed = 'actionFailed',
  ReconnectionRequired = 'reconnectionRequired'
}

export enum SwitchToggleStatus {
  Success = 'success',
  Fail = 'fail',
  Error = 'error'
}
export type SwitchToggleResult = {
  toggleId: string;
  status: SwitchToggleStatus;
};

export type ToggleOauth2Error =
  | {
      type: ToggleOauth2ErrorTypes.ActionFailed;
      toggleId: string;
      errorMessage: string;
    }
  | {
      type: ToggleOauth2ErrorTypes.ReconnectionRequired;
      toggleId: string;
    };

export interface AppIntegrationSlice {
  switchToggleResult: SwitchToggleResult | undefined;
  oauth2error: ToggleOauth2Error | undefined;
  processedIds: string[];
  testedIds: string[];
}

const initialState: AppIntegrationSlice = {
  switchToggleResult: undefined,
  oauth2error: undefined,
  processedIds: [],
  testedIds: []
};

export const appIntegrationSlice = createSlice({
  name: 'appIntegration',
  initialState,
  reducers: {
    setSwitchToggleResult: (state, action: PayloadAction<SwitchToggleResult | undefined>) => {
      state.switchToggleResult = action.payload;
    },
    clearSwitchToggleResult: state => {
      state.switchToggleResult = undefined;
    },

    setOauthError: (state, action: PayloadAction<ToggleOauth2Error | undefined>) => {
      state.oauth2error = action.payload;
    },
    clearOauthError: state => {
      state.oauth2error = undefined;
    },
    addProcessedId: (state, action: PayloadAction<string>) => {
      const newIds = new Set([...state.processedIds, action.payload]);

      state.processedIds = Array.from(newIds);
    },
    removeProcessedId: (state, action: PayloadAction<string>) => {
      state.processedIds = state.processedIds.filter(id => id !== action.payload);
    },
    addTestedId: (state, action: PayloadAction<string>) => {
      const newIds = new Set([...state.testedIds, action.payload]);

      state.testedIds = Array.from(newIds);
    },
    removeTestedId: (state, action: PayloadAction<string>) => {
      state.testedIds = state.testedIds.filter(id => id !== action.payload);
    }
  }
});

export const {
  setOauthError,
  clearOauthError,
  addProcessedId,
  removeProcessedId,
  addTestedId,
  removeTestedId,
  setSwitchToggleResult,
  clearSwitchToggleResult
} = appIntegrationSlice.actions;

export default appIntegrationSlice.reducer;
